import { useParams } from 'react-router-dom';

import { useGetProjectQuery } from '@verantos-dev/data-access-projects';

import { useGetCohortQuery } from './cohortAPISlice';

export const useCohortBuilderData = () => {
  const { projectId, cohortId, cohortVersionId } = useParams();

  const {
    data: projectData,
    error: projectError,
    isSuccess: isProjectSuccess,
  } = useGetProjectQuery(projectId || '', { skip: !projectId });
  const {
    data,
    error: cohortError,
    isSuccess: isCohortSuccess,
  } = useGetCohortQuery(
    { projectId: projectId || '', cohortId: cohortId || '' },
    {
      skip: !projectId || !cohortId,
    }
  );

  return {
    projectId,
    cohortId,
    cohortVersionId,
    latestCohortVersionId: data?.data?.latestCohortVersionId,
    data,
    cohortError,
    isCohortSuccess,
    projectData,
    projectError,
    isProjectSuccess,
  };
};
